module.exports = __webpack_public_path__ + "static/media/10B.ca64ddba.png";